import React, { useMemo } from 'react'
import Error from 'images/inline/spot-the-diff/error.svg'
import {
  MODAL_NEUTRAL_TITLE,
  MODAL_NEUTRAL_SUBTITLE,
  MODAL_WIN_TITLE,
  MODAL_WIN_SUBTITLE,
  MODAL_LOSE_TITLE,
  MODAL_LOSE_SUBTITLE,
  GAME_TYPE,
} from 'steps/drag-and-drop/constants'

const CompletionSummary = ({
  everyCorrect = false,
  onClose,
  totalNumber,
  correctNumber,
  lastStep,
  gameType,
}) => {
  const [summary, summarySubtitle] = useMemo(() => {
    if (everyCorrect) {
      return [MODAL_WIN_TITLE, MODAL_WIN_SUBTITLE]
    }
    if (gameType === GAME_TYPE.RANKING) {
      return [MODAL_NEUTRAL_TITLE, MODAL_NEUTRAL_SUBTITLE]
    }

    return [
      MODAL_LOSE_TITLE,
      MODAL_LOSE_SUBTITLE({ correctNumber, totalNumber }),
    ]
  }, [everyCorrect, gameType, correctNumber, totalNumber])

  return (
    <div className="summary-modal">
      <div className="summary-modal__header">
        {!lastStep && (
          <button className="modal__button" onClick={onClose}>
            <Error />
          </button>
        )}
      </div>
      <div className="completion__summary">
        <div className="summary-modal__title">{summary}</div>
        <div className="summary-modal__text">{summarySubtitle}</div>
      </div>
    </div>
  )
}

export default CompletionSummary
